module.exports = __webpack_public_path__ + "static/media/waiting.a191ef89.png";